(function() {
    'use strict';
    angular.module('cabinFlightAdmin').controller('cabinFlightAdminCtrl', cabinFlightAdminCtrl);

    function cabinFlightAdminCtrl($sce) {
        var vm = this;
    }
}());